import { createFileRoute } from '@tanstack/react-router';

import Content from '@/routes/_authenticated/hilfe/organisationsverwaltung.mdx';

export const Route = createFileRoute('/_authenticated/hilfe/organisationsverwaltung')({
  component: Content,
});
